module.exports = __webpack_public_path__ + "img/Invalidite.6f68c775.jpg";